import type { ApprovalChain } from '../approval-chain.model';

export const RECTIFICATION_CHAIN: ApprovalChain = {
  id: 'rectification',
  label: 'Rectification',
  applicationTypes: ['RECTIFICATION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
